import moment from 'moment-timezone';

/**
 * @module store/tasks/actions
 */

/**
 * Returns tasks assigned to current user
 */
export function getTotalAndIncompleteTasksCount({ commit, rootGetters }, { updateLastChecked } = {}) {
  const { LastCheckedTasks, UserCreatedOn } = rootGetters.userDetails;
  const lastCheckedTasks = moment(LastCheckedTasks || UserCreatedOn || '1970-01-01T00:00:00.000')
    .utc()
    .format('YYYY-MM-DDTHH:mm:ss');
  let url = `/api/tasks/count?lastCheckedTasks=${lastCheckedTasks}`;
  if (updateLastChecked) {
    url += '&updateLastChecked=true';
  }
  return this.$axios.$get(url).then((tasksCount) => {
    commit('setTotalTasksCount', tasksCount.totalTasks);
    commit('setIncompleteTasksCount', tasksCount.incompleteTasks);
    commit('setOpenTasksCount', tasksCount.openTasks);
    if (updateLastChecked) {
      commit('user-login/setLastCheckedTasks', new Date(), { root: true });
    }
  });
}
